import { useLocation } from "react-router-dom";

import { CATALOG_PATH_SEPARATOR } from "modules/MatchingModule/consts/paths";

export const useIsFindInCatalogOpened = () => {
  const { pathname } = useLocation();
  return pathname.includes(`/${CATALOG_PATH_SEPARATOR}/`)
}
